import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import LoggedLayout from '../../layouts/LoggedLayout';
import PageHeader from 'components/PageHeader';
import { default as SuppliesService } from 'services/Supplies';

export default function AllowedCodes(props) {
	let type = props.type;

	let [forceReload, setForceReload] = useState(null);
	let [codes, setCodes] = useState(null);
	let [newCode, setNewCode] = useState(null);

	useEffect(() => {
		let getData = async () => {
			let codes = await SuppliesService.getAllowedCodesList(type);
			setCodes(codes);
		}
		getData();
	}, [forceReload, type]);

	const addNewCode = async () => {
		let result = await SuppliesService.addAllowedCode(newCode, type);
		if ( result?.status === 1 ) {
			toast.success('Código añadido');
			setCodes(null);
			setNewCode(null);
			setForceReload(Math.random());
		} else {
			toast.error('Error al añadir el código');
		}
	}

	const removeCode = async (id) => {
		const c = window.confirm('¿Seguro que quieres eliminar el código?');
		if ( !c ) return false;

		let result = await SuppliesService.removeAllowedCode(id);
		if ( result?.status === 1 ) {
			toast.success('Código borrado');
			setForceReload(Math.random());
		} else {
			toast.error('Error al borrar el código');
		}
	}
	
	return (
		<LoggedLayout>
			<PageHeader className="mb-3" style={{ maxWidth: '700px', margin: 'auto' }}>
				<NavLink to={-1} className="btn-sm btn-light p-0 px-2 float-start" style={{
					border: '1px solid var(--plenoil-black)',
					background: 'transparent',
					borderRadius: '100%',
					width: '25px',
					height: '25px',
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'nowrap',
					justifyContent: 'center',
					alignItems: 'center',
					marginRight: '5px'
				}}>
					<i className="bi bi-chevron-left" style={{
						fontSize: '1rem',
						lineHeight: '100%',
						color: 'var(--plenoil-black)'
					}}></i>
				</NavLink>
				<span className="header-column header-title">Suministros</span>
				<span className="header-column header-icon-end">
					<i className="bi bi-printer text-plenoil-gray"></i>
				</span>
			</PageHeader>

			<div className="pt-2 col-md-12 h-100 row p-4 background-color-blanco shadow rounded" style={{ maxWidth: '700px', margin: 'auto' }}>
				<div className="col-md-12 text-uppercase">
					Códigos de artículos de suministros de <u>{type === 'station' ? 'Estaciónes' : 'Lavaderos'}</u>
				</div>

				<div className="col-md-12 mt-3">
					<div className="input-group input-group-sm mb-3 d-flex justify-content-center flex-nowrap">
						<span className='control-label me-2'>Añadir código</span>
						<input type="text" className="form-control form-control_flotas control-input no-arrows" value={newCode ?? ''} onChange={(e) => setNewCode(e.target.value)} />
						<button className="btn-plenoil btn-plenoil-outline-light" onClick={addNewCode} disabled={!newCode?.length}>Añadir</button>
					</div>
				</div>

				<div className="pt-2 col-md-12">
					<div className="px-0 col-lg pl-lg-0">
						<div className="row m-0 pb-2">
							<div className="col-12 px-0">
								<div className="h-100 p-0 background-color-blanco">
									<div className="table-responsive-rows">
										<div className="mvc-grid mvc-grid-header-mode">
											<div className="mvc-grid-table">
												<table>
													<thead>
														<tr>
															<th>Código</th>
														</tr>
													</thead>
													<tbody>
														{codes && codes.map((el, idx) => {
															return (
																<tr key={idx}>
																	<td>
																		<button className="btn-icon-red btn-plenoil-link me-2" style={{width: 25, height: 25, padding: '0px'}} onClick={() => removeCode(el.id)}><i className="bi bi-x"></i></button>
																		{el.code}
																	</td>
																</tr>
															);
														})}
														{codes?.length === 0 && <tr><td colSpan="100%">No hay códigos disponibles</td></tr>}
														{!codes && <tr><td colSpan="100%">Cargando...</td></tr>}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LoggedLayout>
	);
}